import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Use backend URL from environment
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check session on mount
  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/auth/me`,
        { withCredentials: true }
      );
      
      if (response.data) {
        setUser(response.data);
        setIsAdmin(response.data.isAdmin || false);
      }
    } catch (error) {
      // Not logged in
      setUser(null);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  const login = (userData, admin = false) => {
    setUser(userData);
    setIsAdmin(admin);
  };

  const logout = async () => {
    try {
      await axios.post(
        `${BACKEND_URL}/api/auth/logout`,
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.error('Logout error:', error);
    }
    
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('cart');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        isAdmin,
        login,
        logout,
        isAuthenticated: !!user,
        refreshSession: checkSession
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
